import './bootstrap-icons.css'
import { useEffect, useState } from 'react'
import { loadDomainSpecificCSS } from './global/GlobalCss.tsx'
import './App.css'
import React from 'react'
//import AppRoutes from './routes/AppRoutes.tsx'
import { useSelector } from 'react-redux'
import AppRoutes from './Routes/AppRoutes.tsx'
import { useDispatch } from 'react-redux'
import { AppDispatch } from './global/config/store.ts'
import { fetchClientList } from './global/config/Reducer/clientSlice.ts'

function App () {
  const isLoading = useSelector((store: any) => store.isLoading)
  const loader = useSelector((store: any) => store.redirect)
  const dispatch = useDispatch<AppDispatch>();
  useEffect(() => {
    dispatch(fetchClientList());
  }, [dispatch]);
  useEffect(() => {
    loadDomainSpecificCSS()
  }, [])
  return (
    // <div className='App'>
    //   <AppRoutes />
    //   {isLoading && (
    //     <div
    //       className='loader-overlay'
    //       style={{ display: `${loader ? 'flex' : 'none'}` }}
    //     >
    //       <div className='spinner'>
    //         <div className='clip-loader'></div>
    //       </div>
    //     </div>
    //   )}
    // </div>
    <div className="App">
      <AppRoutes />
      {isLoading && (
        <div
          className="loader-overlay"
          style={{
            display: loader ? 'flex' : 'none',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0, 0, 0, 0.8)',
            zIndex: 9999,
          }}
        >
          <div
            style={{
              border: '4px solid rgba(255, 255, 255, 0.3)',
              borderRadius: '50%',
              borderTop: '4px solid white',
              width: 35,
              height: 35,
              animation: 'spin 0.6s linear infinite',
            }}
          ></div>

          {/* Add animation style manually */}
          <style>
            {`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}
          </style>
        </div>
      )}
    </div>
  )
}
export default App
